/**
 * ScoreRing — large gradient (gold→orange) progress ring.
 * Used on the Report screen for total_score / 100.
 */
export default function ScoreRing({ value = 0, size = 220, strokeWidth = 18, testId }) {
  const safe = Math.max(0, Math.min(100, Number(value) || 0));
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (safe / 100) * circumference;
  const gradId = `score-ring-grad-${size}`;

  return (
    <div
      data-testid={testId || 'score-ring'}
      className="relative inline-flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} className="-rotate-90">
        <defs>
          <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FFC233" />
            <stop offset="100%" stopColor="#FF6B1A" />
          </linearGradient>
        </defs>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="hsl(var(--border))"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={`url(#${gradId})`}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: 'stroke-dashoffset 0.8s cubic-bezier(0.4, 0, 0.2, 1)' }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span
          className="text-5xl font-bold tracking-tight font-heading"
          style={{
            background: 'linear-gradient(135deg, #FFC233 0%, #FF6B1A 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          {Math.round(safe)}
        </span>
        <span className="text-[11px] text-muted-foreground font-medium mt-1 tracking-[0.15em] uppercase font-heading">
          out of 100
        </span>
      </div>
    </div>
  );
}
